import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import React from 'react';

import { MainSkeleton } from './components/Skeleton';

/**
 * Section: Main
 *
 * @param currentTarget
 * @param hasData
 * @param isFetching
 * @param targetRef
 * @param widgets
 * @returns {Element}
 * @constructor
 */
export function Main({ currentTarget = '', hasData = false, isFetching = false, targetRef = null, widgets = [] }) {
  return (
    <ErrorHandler location="src/layouts/Dashboard/sections/Main/Main.jsx">
      <Layout.Stack
        alignItems="left"
        alignLayout="left"
        data-testid="layout-dashboard-main"
        grow
        id="layout-dashboard-main"
      >
        {isFetching ? (
          <MainSkeleton count={widgets.length} />
        ) : (
          <React.Fragment>
            {hasData && (
              <React.Fragment>
                {widgets.map((widget) => {
                  const { element: WidgetElement } = widget;

                  return (
                    <Widget
                      accessor={widget?.accessor}
                      collapsed={false}
                      collapsible
                      description={widget?.description}
                      icon={widget?.icon}
                      key={widget?.title}
                      panel={widget?.panel}
                      title={widget?.title}
                    >
                      <div ref={widget?.accessor === currentTarget ? targetRef : null}>{WidgetElement}</div>
                    </Widget>
                  );
                })}
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </Layout.Stack>
    </ErrorHandler>
  );
}
